import React, {useEffect} from "react";
import {Notify} from "../domains/common/components/AlertNotify";
import Box from "@mui/material/Box";
import {getAuthorizeURL} from "../fn";
import {Link1} from "../domains/common/components/Typography";

export const redirectToAckAccess = () => {
  const url = `/ackaccess/`
  window.location.replace(url);
}

export default function AckAccess() {
  const [notify, openNotify] = Notify({open: false});

  useEffect(() => openNotify({
    msg: "Вход запрещен. Обратитесь к администратору для получения доступа",
    duration: 10000,
    type: 'error',
    positionH: 'right',
  }), [])

  return (
    <Box display="flex" height={200}>
      <Box m="auto" sx={{textAlign: 'center'}}>
        Вход ограничен. Обратитесь к администратору для получения доступа.
        <p/>
        <Link1 href={getAuthorizeURL()}>Перейти к авторизации</Link1>
      </Box>
    </Box>)
}
